/* eslint-disable */
import React, { useEffect } from 'react';
import LogoLoader from 'src/newSrc2/components/LogoLoader';

const GlobalLoader = ({ loading }) => {
  useEffect(() => {
    document.body.style.overflow = loading ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [loading]);

  if (!loading) return null;

  return (
    <div className='tw-fixed tw-inset-0 tw-z-[9999] tw-flex tw-items-center tw-justify-center tw-bg-white/30 tw-backdrop-blur-sm'>
      <div className='tw-flex tw-items-center tw-justify-center tw-rounded-2xl tw-bg-transparent tw-p-6'>
        <LogoLoader />
      </div>
    </div>
  );
};

export default GlobalLoader;
